import { useState } from "react";
import { motion } from "framer-motion";
import { TrashSimple, Minus, Plus, ImageBroken } from "@phosphor-icons/react";
import { getCurrencySymbol } from "../lib/currency";

export function MobileQuoteItemRow({ item, currency, onDelete, onQtyChange, onEdit }) {
  const [dragX, setDragX] = useState(0);
  const symbol = getCurrencySymbol(currency);

  return (
    <div className="relative rounded-[18px] overflow-hidden" data-testid={`mobile-quote-item-row-${item.item_id}`}>
      <div className="absolute inset-y-0 right-0 w-20 bg-[#9A3412] flex items-center justify-center">
        <TrashSimple size={20} weight="bold" className="text-white" />
      </div>
      <motion.div
        drag="x"
        dragConstraints={{ left: -80, right: 0 }}
        dragElastic={0.15}
        onDrag={(_, info) => setDragX(info.offset.x)}
        onDragEnd={(_, info) => {
          if (info.offset.x < -55) {
            onDelete(item.item_id);
          } else {
            setDragX(0);
          }
        }}
        animate={{ x: dragX < -55 ? -80 : 0 }}
        className="bg-white border border-[#E7E5E4] rounded-[18px] p-3 flex items-center gap-3 relative"
      >
        <div className="w-14 h-14 rounded-[12px] bg-[#FAFAF9] flex items-center justify-center overflow-hidden flex-shrink-0">
          {item.photo_url ? (
            <img src={item.photo_url} alt={item.description} className="w-full h-full object-cover" />
          ) : (
            <ImageBroken size={18} className="text-[#E7E5E4]" />
          )}
        </div>
        <div className="flex-1 min-w-0" onClick={() => onEdit && onEdit(item)} data-testid={`mobile-quote-item-edit-${item.item_id}`}>
          <p className="text-sm font-medium text-[#1C1917] truncate">{item.description || "-"}</p>
          <p className="text-xs text-[#78716C] mt-0.5 truncate">{item.item_no} &middot; {item.size || "-"}{item.remark ? ` · ${item.remark}` : ""}</p>
          <p className="text-sm font-semibold text-[#1E3A8A] mt-1">
            {item.final_price != null ? `${symbol}${Number(item.final_price).toFixed(2)}` : "-"}
          </p>
        </div>
        <div className="flex items-center gap-1.5 flex-shrink-0" onPointerDown={(e) => e.stopPropagation()}>
          <button
            onClick={() => onQtyChange(item.item_id, Math.max(0, item.carton_qty - 1))}
            data-testid={`mobile-quote-item-qty-minus-${item.item_id}`}
            className="press-scale w-7 h-7 rounded-full bg-[#FAFAF9] border border-[#E7E5E4] flex items-center justify-center text-[#78716C]"
          >
            <Minus size={12} weight="bold" />
          </button>
          <span className="w-7 text-center text-sm font-semibold text-[#1C1917]" data-testid={`mobile-quote-item-qty-${item.item_id}`}>
            {item.carton_qty}
          </span>
          <button
            onClick={() => onQtyChange(item.item_id, item.carton_qty + 1)}
            data-testid={`mobile-quote-item-qty-plus-${item.item_id}`}
            className="press-scale w-7 h-7 rounded-full bg-[#1E3A8A] flex items-center justify-center text-white"
          >
            <Plus size={12} weight="bold" />
          </button>
        </div>
      </motion.div>
    </div>
  );
}
